/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.Instructions";
        class InstructionsWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("InstructionsWidgetTypeClass.createInstance()");
                    return new InstructionsInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("InstructionsWidgetTypeClass._storeHtml()");
                    InstructionsInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("InstructionsWidgetTypeClass::constructor");
                this._allowedOnLogon = true;
                if (InstructionsInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/Instructions/instructions.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.InstructionsWidgetTypeClass = InstructionsWidgetTypeClass;
        class InstructionsInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._list = null;
                this._tempDOM = null;
                this._loader = null;
                this._usageAllowed = true;
                this.presentInstance = () => {
                    this._log.info("InstructionsInstanceClass.presentInstance()");
                    this._container.innerHTML = InstructionsInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._list = this._container.querySelector('#instructionsList');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#instructionsWidgetTitle'), 'STR_WPT_INSTRUCTIONS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#instructionsLoading'), 'STR_WPT_LOADING');
                    this._list.innerHTML = "";
                    if (this._usageAllowed) {
                        this._core.Functions.showElement(this._loader);
                        let config = this._config;
                        if (config.hasOwnProperty('Path')) {
                            this._core.Loader.getUnversionedJSON(config.Path, this._fillInstructionsList, this._callErrorHandler);
                        }
                        else if (config.hasOwnProperty('Query')) {
                            let requestSearch = this._core.OBHelper.compileFlexSearchFromQueryDef(config.Query);
                            requestSearch.MaxHits = 1;
                            this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._getInstructionsJson, {}, this._callErrorHandler, this._callFailedHandler);
                        }
                        else if (config.hasOwnProperty('FlexQuery')) {
                            let requestSearch = this._core.OBHelper.flexDefinitionToRequest(config.FlexQuery);
                            requestSearch.MaxHits = 1;
                            this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._getInstructionsJson, {}, this._callErrorHandler, this._callFailedHandler);
                        }
                    }
                    this._type.instanceReady(this.getHandle());
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("InstructionsInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callFailedHandler = (json) => {
                    this._log.info("InstructionsInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._getInstructionsJson = (response) => {
                    this._log.info("InstructionsInstanceClass._getInstructionsJson()");
                    if (response.hasOwnProperty('Documents') && response.Documents.length > 0) {
                        let doc = response.Documents[0];
                        let url = '/OnBaseDocumentDownload.ashx?wmode=transparent&id=' + doc.ItemNum;
                        this._core.Loader.genericServiceCallTextData(url, this._receiveInstructionsJson, this._callErrorHandler);
                    }
                    else {
                        console.warn("no documents received");
                        this._core.Functions.hideElement(this._loader);
                    }
                };
                this._receiveInstructionsJson = (textData) => {
                    this._log.info("InstructionsInstanceClass._receiveInstructionsJson()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at content type: " + textData.ContentType);
                    }
                    try {
                        let instructionsData = JSON.parse(textData.ContentText);
                        this._fillInstructionsList(instructionsData);
                    }
                    catch (ex) {
                        console.warn("failed to get Instructions JSON: " + ex.message);
                        let msgPrefix = this._core.Locale.getTranslation('STR_WPT_INSTRUCTIONS_ERROR_MSG');
                        let errorMsg = msgPrefix + ": " + ex.message;
                        this.addError(errorMsg);
                        this._core.Functions.hideElement(this._loader);
                    }
                };
                this._fillInstructionsList = (instructionsData) => {
                    this._log.info("InstructionsInstanceClass._fillInstructionsList()");
                    this._list.innerHTML = "";
                    this._core.Functions.hideElement(this._loader);
                    if (instructionsData.hasOwnProperty('Instructions')) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("found Instructions");
                        }
                        let instructionsSets = instructionsData.Instructions;
                        let instructionsSetsLength = instructionsSets.length;
                        let rows = null;
                        let selectedLang = this._core.Locale.getSelectedLocale().LangFileCode;
                        for (let i = 0; i < instructionsSetsLength; i++) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at instructions set: " + (i + 1));
                            }
                            let instructionsSet = instructionsSets[i];
                            if (instructionsSet.hasOwnProperty('Lang')) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("looking at instructions set for language: " + instructionsSet.Lang);
                                }
                                if (instructionsSet.Lang === selectedLang) {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace("is selected language");
                                    }
                                    if (instructionsSet.hasOwnProperty('Rows')) {
                                        if (this._log.isTraceEnabled()) {
                                            this._log.trace("rows set");
                                        }
                                        rows = instructionsSet.Rows;
                                    }
                                    break;
                                }
                            }
                        }
                        if (rows == null) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("rows not set yet, using first instructions set");
                            }
                            let instructionsSet = instructionsSets[0];
                            if (instructionsSet != null && instructionsSet != undefined) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("using first instructions set");
                                }
                                if (instructionsSet.hasOwnProperty('Rows')) {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace("rows set");
                                    }
                                    rows = instructionsSet.Rows;
                                }
                            }
                            else {
                                console.warn("no instructions set found");
                            }
                        }
                        if (rows != null) {
                            this._tempDOM = document.createDocumentFragment();
                            rows.forEach(this._appendInstruction);
                            this._list.appendChild(this._tempDOM);
                            this._tempDOM = null;
                        }
                    }
                };
                this._appendInstruction = (instruction) => {
                    this._log.info("InstructionsInstanceClass._appendInstruction()");
                    let item = document.createElement('li');
                    this._tempDOM.appendChild(item);
                    let prefixSpan = document.createElement('span');
                    item.appendChild(prefixSpan);
                    prefixSpan.classList.add('instruction-prefix');
                    prefixSpan.appendChild(document.createTextNode(instruction.Prefix));
                    let contentSpan = document.createElement('span');
                    item.appendChild(contentSpan);
                    contentSpan.classList.add('instruction-content');
                    contentSpan.appendChild(document.createTextNode(instruction.Row));
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("InstructionsInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                if (!core.isUserLoggedIn() && !config.hasOwnProperty('Path') && config.hasOwnProperty('Query')) {
                    let msg = core.Locale.getTranslation('STR_WPT_LOGON_NOT_ALLOWED_SETTING') + ": Query";
                    this.addError(msg);
                    this._usageAllowed = false;
                }
            }
        }
        InstructionsInstanceClass.HtmlData = null;
        Widgets.InstructionsInstanceClass = InstructionsInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
